import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowLeft } from 'lucide-react';
import { LanguageProvider, useI18n } from '@/context/LanguageContext';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Logo } from '@/components/Logo';

// Thank You page is SPANISH-ONLY per requirements, located at /thank_you.
function ThankYouInner() {
  const { t } = useI18n();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = t('thankyou.title');
    document.documentElement.lang = 'es-AR';
  }, [t]);

  return (
    <div className="inv-content flex min-h-screen flex-col bg-[hsl(var(--inv-surface))]">
      <div className="border-b border-border/70 bg-background">
        <div className="mx-auto flex h-16 max-w-[1120px] items-center px-4 sm:px-6 lg:px-8">
          <Link to="/" data-testid="thankyou-logo-link">
            <Logo />
          </Link>
        </div>
      </div>

      <div className="flex flex-1 items-center justify-center px-4 py-16">
        <Card className="w-full max-w-lg border-border/70 p-8 text-center shadow-[var(--shadow-md)] sm:p-10">
          <span className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-full bg-[hsl(var(--inv-terracotta-soft))]">
            <CheckCircle2 className="h-7 w-7 text-[hsl(var(--inv-terracotta))]" />
          </span>
          <p className="mt-5 font-mono text-xs uppercase tracking-[0.18em] text-[hsl(var(--inv-terracotta))]">
            {t('thankyou.kicker')}
          </p>
          <h1 className="mt-3 font-heading text-2xl font-semibold tracking-tight text-[hsl(var(--inv-slate))] sm:text-3xl">
            {t('thankyou.title')}
          </h1>
          <p className="mx-auto mt-4 max-w-md text-[15px] leading-relaxed text-muted-foreground">
            {t('thankyou.message')}
          </p>
          <p className="mx-auto mt-3 max-w-md text-sm text-muted-foreground">{t('thankyou.note')}</p>
          <Link to="/" data-testid="thank-you-back-home-button">
            <Button className="mt-7 bg-[hsl(var(--inv-blue))] text-[hsl(var(--primary-foreground))] transition-colors hover:bg-[hsl(var(--inv-blue-2))] active:scale-[0.99]">
              <ArrowLeft className="mr-1.5 h-4 w-4" />
              {t('thankyou.backHome')}
            </Button>
          </Link>
        </Card>
      </div>
    </div>
  );
}

export default function ThankYou() {
  return (
    <LanguageProvider lang="ar">
      <ThankYouInner />
    </LanguageProvider>
  );
}
